import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_v_radio = _resolveComponent("v-radio");
    const _component_v_radio_group = _resolveComponent("v-radio-group");
    const _component_v_autocomplete = _resolveComponent("v-autocomplete");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_CardSection = _resolveComponent("CardSection");
    return (_openBlock(), _createBlock(_component_CardSection, {
        title: _ctx.$t(`${_ctx.storeDetailLc}edit_reception_operation`)
    }, {
        default: _withCtx(() => [
            _createCommentVNode(" 접수 가능 결제방식 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.storeDetailLc}goods_pay_restrict_type`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                        "item-title": "text",
                        "item-value": "key",
                        modelValue: _ctx.goodsPayRestrictType,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.goodsPayRestrictType) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        "menu-props": { contentClass: 'brg-select-option' },
                        items: _ctx.goodsPayRestrictTypeOptionList
                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 상품 대금 전달 방식"),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.storeDetailLc}goods_pay_type`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.goodsPayType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.goodsPayType) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        "menu-props": { contentClass: 'brg-select-option' },
                        items: _ctx.goodsPayTypeOptionList
                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 완료전 상품대금 정산 "),
            (_ctx.isCashType)
                ? (_openBlock(), _createBlock(_component_InputRow, {
                    key: 0,
                    label: _ctx.$t(`${_ctx.storeDetailLc}is_send_baromoney_required`),
                    "is-required": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio_group, {
                            modelValue: _ctx.isSendBaromoneyRequired,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.isSendBaromoneyRequired) = $event)),
                            inline: "",
                            density: "compact",
                            "hide-details": "auto"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sendBaromoneyRequiredOptionList, (option, key) => {
                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                        key: key,
                                        label: option.text,
                                        value: option.value
                                    }, null, 8 /* PROPS */, ["label", "value"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 현금영수증 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.storeDetailLc}is_cash_receipts_required`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_radio_group, {
                        modelValue: _ctx.isCashReceiptsRequired,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.isCashReceiptsRequired) = $event)),
                        inline: "",
                        density: "compact",
                        "hide-details": "auto"
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cashReceiptsRequiredOptionList, (option, key) => {
                                return (_openBlock(), _createBlock(_component_v_radio, {
                                    key: key,
                                    label: option.text,
                                    value: option.value
                                }, null, 8 /* PROPS */, ["label", "value"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 픽업소요시간 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.storeDetailLc}cooking_time`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_autocomplete, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.cookingTime,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.cookingTime) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        items: _ctx.cookingTimeOptionList,
                        onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.handleBlurCookingTime(_ctx.cookingTime)))
                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 접수 가능 건수 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.storeDetailLc}day_delivery_available_count`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                        modelValue: _ctx.dayDeliveryCount,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.dayDeliveryCount) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        suffix: _ctx.$t(`${_ctx.storeDetailLc}day_delivery_count_suffix`),
                        oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                        rules: _ctx.formRules.dayDeliveryCount,
                        maxlength: _ctx.DAY_DELIVERY_COUNT_MAX_LENGTH,
                        onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.handleBlurDayDeliveryCount(_ctx.dayDeliveryCount)))
                    }, null, 8 /* PROPS */, ["modelValue", "suffix", "rules", "maxlength"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 자동 취소시간 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.storeDetailLc}delivery_cancel_time`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_autocomplete, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.deliveryCancelTime,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.deliveryCancelTime) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        items: _ctx.deliveryCancelTimeOptionList,
                        onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.handleBlurDeliveryCancelTime(_ctx.deliveryCancelTime)))
                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 접수 제한 잔액 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.storeDetailLc}order_limit_baromoney`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                        modelValue: _ctx.orderLimitBaromoney,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.orderLimitBaromoney) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        suffix: _ctx.$t(`${_ctx.storeDetailLc}order_limit_balance_suffix`),
                        oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                        maxlength: _ctx.ORDER_LIMIT_BAROMONEY_MAX_LENGTH,
                        onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.handleBlurOrderLimitBaromoney(_ctx.orderLimitBaromoney)))
                    }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 접수 제한 금액 부족 시 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.storeDetailLc}insufficient_baromoney_unaccept_yn`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_radio_group, {
                        modelValue: _ctx.isInsufficientBaromoneyUnAccept,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.isInsufficientBaromoneyUnAccept) = $event)),
                        inline: "",
                        density: "compact",
                        "hide-details": "auto"
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insufficientBaromoneyUnAcceptOptionList, (option, key) => {
                                return (_openBlock(), _createBlock(_component_v_radio, {
                                    key: key,
                                    label: option.text,
                                    value: option.value
                                }, null, 8 /* PROPS */, ["label", "value"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 배달대행료 미설정 구간 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.storeDetailLc}is_delivery_charge_non_setting_unaccept`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_radio_group, {
                        modelValue: _ctx.isDeliveryChargeNonSettingUnAccept,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.isDeliveryChargeNonSettingUnAccept) = $event)),
                        inline: "",
                        density: "compact",
                        "hide-details": "auto"
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryChargeNonSettingUnAcceptOptionList, (option, key) => {
                                return (_openBlock(), _createBlock(_component_v_radio, {
                                    key: key,
                                    label: option.text,
                                    value: option.value
                                }, null, 8 /* PROPS */, ["label", "value"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createCommentVNode(" 기본 할증기능 "),
            _createVNode(_component_InputRow, {
                label: _ctx.$t(`${_ctx.storeDetailLc}add_charge_use_yn`),
                "is-required": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_radio_group, {
                        modelValue: _ctx.addChargeUseYn,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.addChargeUseYn) = $event)),
                        inline: "",
                        density: "compact",
                        "hide-details": "auto"
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addChargeUseYnOptionList, (option, key) => {
                                return (_openBlock(), _createBlock(_component_v_radio, {
                                    key: key,
                                    label: option.text,
                                    value: option.value
                                }, null, 8 /* PROPS */, ["label", "value"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title"]));
}
